<template>
  <div>
    
    <div class="tr header" v-if="index === 0">
      <div class="th ent-id">ent id</div>
      <div class="th enrol-profile">enrol profile</div>
      <div class="th actility">actility references</div>
      <div class="th storage">storage</div>
      <div class="th group-list">groups</div>
      <div class="th devices">devices</div>
      <div class="th actions">&nbsp;</div>
    </div>

    <div class="tr" :class="{even: index % 2 === 0}">
      <div class="td ent-id">
        <EnterpriseId :enterprise-id="enterprise.enterpriseId"/>
      </div>

      <div class="td enrol-profile">
        <div class="pre">{{getEnrolProfile(enterprise)}}</div>
      </div>

      <div class="td actility">
        <div>supplierId: <span class="pre">{{getSupplierId(enterprise)}}</span></div>
        <div>subscriberId: <span class="pre">{{getSubscriberId(enterprise)}}</span></div>
      </div>

      <div class="td storage">
        <div v-if="!enterprise.dataStorage">
          <span class="disabled">storage: <font-awesome-icon icon="exclamation-circle" /> DISABLED</span>
        </div>
        <div v-else>
          <span class="enabled">storage: <font-awesome-icon icon="check-circle" /> ENABLED</span>
        </div>
        <div v-if="!enterprise.dataDecoding">
          <span class="disabled">decoding: <font-awesome-icon icon="exclamation-circle" /> DISABLED</span>
        </div>
        <div v-else>
          <span class="enabled">decoding: <font-awesome-icon icon="check-circle" /> ENABLED</span>
        </div>
      </div>

      <div class="td group-list">
        <div v-for="groupName in enterprise.groupList" :key="groupName">
          <span class="pre">{{groupName}}</span>
        </div>
      </div>

      <div class="td devices">
        <div>direct: <span class="pre">{{enterprise.numDevices.direct}}</span></div>
        <div>all: <span class="pre">{{enterprise.numDevices.all}}</span></div>
      </div>

      <div class="td actions">
        <button type="button" data-tippy-content="edit" class="btn btn-primary btn-sm" @click="emit('edit', enterprise)"><font-awesome-icon icon="wrench"/></button>
        <button type="button" data-tippy-content="delete" class="btn btn-danger btn-sm" @click="emit('delete', enterprise)" :disabled="!canDelete"><font-awesome-icon icon="trash-alt"/></button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue';
import tippy from 'tippy.js';
import { Enterprise } from '@/types';
import EnterpriseId from '@/components/EnterpriseId.vue';

interface Props {
  enterprise: Enterprise;
  index: number;
}

const props = withDefaults(defineProps<Props>(), {
  enterprise: () => ({}) as Enterprise,
  index: 0
});

const emit = defineEmits<{
  edit: [enterprise: Enterprise];
  delete: [enterprise: Enterprise];
}>();


onMounted(async () => {
  tippy('[data-tippy-content]');
});

const getEnrolProfile = (ent: Enterprise): string => {
  return ent.nwServer && ent.nwServer.actility && ent.nwServer.actility.enrolId ? ent.nwServer.actility.enrolId : 'default';
};

const getSubscriberId = (ent: Enterprise): string => {
  return ent.nwServer && ent.nwServer.actility && ent.nwServer.actility.subscriberId ? `${ent.nwServer.actility.subscriberId}` : 'n/a';
};

const getSupplierId = (ent: Enterprise): string => {
  return ent.nwServer && ent.nwServer.actility && ent.nwServer.actility.supplierId ? `${ent.nwServer.actility.supplierId}` : 'n/a';
};

const canDelete = computed<boolean>(() => {
  return props.enterprise.numDevices.direct === 0 && props.enterprise.numDevices.all === 0;
});

</script>

<style scoped lang="scss">
@use "@/variables.scss" as *;

.tr {
  display: flex;
  flex-direction: row;
  text-align: left;
  justify-content: space-between;
  margin-bottom: 10px;
}

.tr.even {
  background-color: $bgColourLight;
}

.tr.header {
  border-bottom: 1px solid $bgColour;
}

.th {
  color: $bgColour;
  font-weight: bold;
}

.th, .td {
  padding: 3px;
}

.td.ent-id, .th.ent-id {
  width: 25%;
}

.td.enrol-profile, .th.enrol-profile {
  width: 14%;
}

.td.actility, .th.actility {
  width: 25%;
}

.td.storage, .th.storage {
  width: 25%;
}

.td.group-list, .th.group-list {
  width: 25%;
}

.td.devices, .th.devices {
  width: 10%;
}

.td.actions, .th.actions {
  width: 10%;
}

.td.actions button {
  margin:2px;
}

.pre {
  font-family: monospace;
  font-weight: bold;
}

.disabled {
  color:red;
}

.enabled {
  color: green;
}

</style>